module.exports = __webpack_public_path__ + "static/media/RunNUS_Logo_No_Year.4b1c5524.jpg";